export default [
  {
    path: '/report/property',
    name: 'report-property',
    component: () => import('@/views/report/property/ReportProperty.vue'),
    meta: {
      resource: 'report-property',
      action: 'read',
    },
  },
  {
    path: '/report/special-contract',
    name: 'report-special-contract',
    component: () => import('@/views/report/property/special-contract/ReportSpecialContract.vue'),
    meta: {
      resource: 'report-property',
      action: 'read',
    },
  },
  {
    path: '/report/finance',
    name: 'report-finance',
    component: () => import('@/views/report/finance/ReportFinance.vue'),
    meta: {
      resource: 'report-finance',
      action: 'read',
    },
  },
  {
    path: '/report/new-debt',
    name: 'report-new-debt',
    component: () => import('@/views/report/finance/new-debt/ReportNewDebt.vue'),
    meta: {
      resource: 'report-finance',
      action: 'read',
    },
  },
  {
    path: '/report/finance-by-month',
    name: 'report-finance-by-month',
    component: () => import('@/views/report/finance/finance-by-month/FinanceReportByMonth.vue'),
    meta: {
      resource: 'report-finance',
      action: 'read',
    },
  },
  {
    path: '/report/tenant',
    name: 'report-tenant',
    component: () => import('@/views/report/tenant/ReportTenant.vue'),
    meta: {
      resource: 'report-tenant',
      action: 'read',
    },
  },
  {
    path: '/report/task',
    name: 'report-task',
    component: () => import('@/views/report/task/ReportTask.vue'),
    meta: {
      resource: 'report-task',
      action: 'read',
    },
  },
  {
    path: '/report/asset',
    name: 'report-asset',
    component: () => import('@/views/report/asset/ReportAsset.vue'),
    meta: {
      resource: 'report-asset',
      action: 'read',
    },
  },
  {
    path: '/report/property/empty-rooms',
    name: 'report-empty-room',
    component: () => import('@/views/report/property/empty-room/ReportEmptyRoom.vue'),
    meta: {
      resource: 'report-property',
      action: 'read',
    },
  },
  {
    path: '/report/property/percentage-rooms',
    name: 'report-percentage-room',
    component: () => import('@/views/report/property/percentage/ReportPercentageRoom.vue'),
    meta: {
      resource: 'report-property',
      action: 'read',
    },
  },
  {
    path: '/report/property/percentage-rooms-2',
    name: 'report-percentage-room-2',
    component: () => import('@/views/report/property/percentage-2/ReportPercentageRoom.vue'),
    meta: {
      resource: 'report-property',
      action: 'read',
    },
  },
  {
    path: '/report/property/report-promotion',
    name: 'report-promotion',
    component: () => import('@/views/report/property/promotion/ReportPromotion.vue'),
    meta: {
      resource: 'report-property',
      action: 'read',
    },
  },
  {
    path: '/report/property/report-liquid',
    name: 'report-liquid',
    component: () => import('@/views/report/property/liquid/ReportLiquid.vue'),
    meta: {
      resource: 'report-property',
      action: 'read',
    },
  },
  {
    path: '/report/property/near-empty-rooms',
    name: 'report-near-empty-room',
    component: () => import('@/views/report/property/near-empty-room/ReportNearEmptyRoom.vue'),
    meta: {
      resource: 'report-property',
      action: 'read',
    },
  },
  {
    path: '/report/finance/deposit',
    name: 'report-finance-deposit',
    component: () => import('@/views/report/finance/deposit/ReportDeposit.vue'),
    meta: {
      resource: 'report-finance',
      action: 'read',
    },
  },
  {
    path: '/report/finance/curent-deposit',
    name: 'report-deposit-tingtong',
    component: () => import('@/views/report/finance/deposit-tingtong/ReportDeposit.vue'),
    meta: {
      resource: 'report-finance',
      action: 'read',
    },
  },
  {
    path: '/report/finance/cancel-deposit',
    name: 'report-cancel-deposit',
    component: () => import('@/views/report/finance/cancel-deposit/CancelDeposit.vue'),
    meta: {
      resource: 'report-finance',
      action: 'read',
    },
  },
  {
    path: '/report/finance/debt-recovery',
    name: 'debt-recovery',
    component: () => import('@/views/report/finance/debt-recovery/DebtRecovery.vue'),
    meta: {
      resource: 'report-finance',
      action: 'read',
    },
  },

  {
    path: '/report/finance/check-tenant',
    name: 'check-tenant',
    component: () => import('@/views/report/finance/check-tenant/CheckTenant.vue'),
    meta: {
      resource: 'report-finance',
      action: 'read',
    },
  },
  {
    path: '/report/finance/check-invoice',
    name: 'check-invoice',
    component: () => import('@/views/report/finance/check-invoice/CheckInvoice.vue'),
    meta: {
      resource: 'report-finance',
      action: 'read',
    },
  },
  {
    path: '/report/finance/check-ew',
    name: 'check-ew',
    component: () => import('@/views/report/finance/check-ew/CheckEW.vue'),
    meta: {
      resource: 'report-finance',
      action: 'read',
    },
  },
  {
    path: '/report/finance/check-missing-ew',
    name: 'check-missing-ew',
    component: () => import('@/views/report/finance/check-missing-ew/CheckMissingEW.vue'),
    meta: {
      resource: 'report-finance',
      action: 'read',
    },
  },
  {
    path: '/report/property/contract',
    name: 'report-contract',
    component: () => import('@/views/report/property/contract/ReportContract.vue'),
    meta: {
      resource: 'report-property',
      action: 'read',
    },
  },
  {
    path: '/report/finance/check-fee',
    name: 'check-fee',
    component: () => import('@/views/report/finance/check-fee/CheckFee.vue'),
    meta: {
      resource: 'report-finance',
      action: 'read',
    },
  },
  {
    path: '/report/finance/debt',
    name: 'report-debt',
    component: () => import('@/views/report/finance/debt/ReportDebt.vue'),
    meta: {
      resource: 'report-finance',
      action: 'read',
    },
  },
  {
    path: '/report/finance/cash-flow',
    name: 'report-cash-flow',
    component: () => import('@/views/report/finance/cash-flow/ReportCashFlow.vue'),
    meta: {
      resource: 'report-finance',
      action: 'read',
    },
  },
  {
    path: '/report/finance/billing-calendar',
    name: 'report-billing-calendar',
    component: () => import('@/views/report/finance/billing-calendar/BillingCalendar.vue'),
    meta: {
      resource: 'report-finance',
      action: 'read',
    },
  },
  {
    path: '/report/finance/cashbook',
    name: 'report-cashbook',
    component: () => import('@/views/report/finance/cashbook/ReportCashbook.vue'),
    meta: {
      resource: 'report-finance',
      action: 'read',
    },
  },
];
